import React from 'react';
import { createGlobalStyle, css, rem, tablet } from 'theme';

import { Normalized } from './NormalizedStyle';
import * as Elements from './elements';

// Spread imported elements into a new object to add typings.
const globalElements: { [key: string]: React.ComponentClass } = { ...Elements };

const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    line-height: 1.6;
  }

  body {
    font-family: var(--ref-font-family-opensans), sans-serif;
    font-size: ${rem(14)};
    color: var(--ref-color-gray-100);

    ${tablet(css`
      font-size: ${rem(16)};
    `)}
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  @font-face {
    font-family: "Ziggo Headline";
    font-weight: 700;
    font-style: normal;
    font-display: block;
    src:
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2/ziggoheadline-bold.woff2')
        format('woff2'),
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2/ziggoheadline-bold.woff')
        format('woff');
  }

  @font-face {
    font-family: "Ziggo Headline";
    font-weight: 400;
    font-style: normal;
    font-display: block;
    src:
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2/ziggoheadline-regular.woff2')
        format('woff2'),
      url('https://origin.ziggo.nl//assets/fonts/ziggo/v2/ziggoheadline-regular.woff')
        format('woff');
  }

  @font-face {
    font-family: "VodafoneZiggo-Text";
    font-weight: 300;
    font-style: normal;
    font-display: block;
    src:
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2.1/vodafoneziggo-text-light.woff2')
        format('woff2'),
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2.1/vodafoneziggo-text-light.woff')
        format('woff');
  }

  @font-face {
    font-family: "VodafoneZiggo-Text";
    font-weight: 300;
    font-style: italic;
    font-display: block;
    src:
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2.1/vodafoneziggo-text-lightitalic.woff2')
        format('woff2'),
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2.1/vodafoneziggo-text-lightitalic.woff')
        format('woff');
  }

  @font-face {
    font-family: "VodafoneZiggo-Text";
    font-weight: 400;
    font-style: normal;
    font-display: block;
    src:
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2.1/vodafoneziggo-text-regular.woff2')
        format('woff2'),
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2.1/vodafoneziggo-text-regular.woff')
        format('woff');
  }

  @font-face {
    font-family: "VodafoneZiggo-Text";
    font-weight: 400;
    font-style: italic;
    font-display: block;
    src:
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2.1/vodafoneziggo-text-regularitalic.woff2')
        format('woff2'),
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2.1/vodafoneziggo-text-regularitalic.woff')
        format('woff');
  }

  @font-face {
    font-family: "VodafoneZiggo-Text";
    font-weight: 700;
    font-style: normal;
    font-display: block;
    src:
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2.1/vodafoneziggo-text-bold.woff2')
        format('woff2'),
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2.1/vodafoneziggo-text-bold.woff')
        format('woff');
  }

  @font-face {
    font-family: "VodafoneZiggo-Text";
    font-weight: 700;
    font-style: italic;
    font-display: block;
    src:
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2.1/vodafoneziggo-text-bolditalic.woff2')
        format('woff2'),
      url('https://origin.ziggo.nl/assets/fonts/ziggo/v2.1/vodafoneziggo-text-bolditalic.woff')
        format('woff');
  }
`;

export default () => (
  <React.Fragment>
    <Normalized />
    <GlobalStyle />
    {/* Iterate over all elements and return its components */}
    {Object.keys(globalElements).map((elementName) => {
      const Component = globalElements[elementName];
      return <Component key={elementName} />;
    })}
  </React.Fragment>
);
